import { IconAdd64 } from '@/assets';
import ButtonAnimation from '@/components/common/ButtonAnimation';
import DownloadPortfolioModal from '@/components/common/Modal';
import { LinkPortfolio } from '@/constants/common';
import { ERoutePath } from '@/constants/route';
import Header from '@/layouts/Header';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title: React.ReactNode;
  desc: string;
}

const SectionFirstPage = ({ title, desc }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="section-first-page">
      <Header />
      <div className="section-first-page__top">
        <div className="section-first-page__top-left">{title}</div>
        <div className="section-first-page__top-right">
          <IconAdd64 />
          <p className="desc-mobile">{desc}</p>
          <div className="btn-section-first-page">
            <ButtonAnimation title={t('Download Portfolio')} onClick={() => setIsOpen(true)} />
            {ERoutePath.TRADING_SYSTEM_SOLUTIONS === window.location.pathname && (
              <ButtonAnimation
                title={t('Trading History')}
                onClick={() => window.open(LinkPortfolio, '_blank')}
              />
            )}
            {[ERoutePath.CORE_SERVICES, ERoutePath.COMPANY_INFORMATION].includes(
              window.location.pathname as ERoutePath
            ) && (
              <ButtonAnimation
                title={t('Request Consultation')}
                onClick={() => window.open(LinkPortfolio, '_blank')}
              />
            )}
          </div>
        </div>
      </div>
      <div className="section-first-page__desc">
        <p>{desc}</p>
      </div>
      <div className="video">
        <video autoPlay loop muted playsInline src="/video/video-section-first-page.mp4"></video>
      </div>
      <DownloadPortfolioModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />
    </div>
  );
};

export default React.memo(SectionFirstPage);
